import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const TechnicalServicesSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const technicalServices = [
    {
      title: language === 'fr' ? 'Maintenance préventive et curative' : 
             language === 'ar' ? 'الصيانة الوقائية والعلاجية' : 
             'Preventive and curative maintenance',
      description: language === 'fr' 
        ? 'Services de maintenance préventive et curative pour débitmétrie et analyseurs en ligne, assurant la fiabilité et la précision de vos équipements de mesure.' 
        : language === 'ar' 
        ? 'خدمات الصيانة الوقائية والعلاجية لأجهزة قياس التدفق والمحللات عبر الإنترنت، مما يضمن موثوقية ودقة معدات القياس الخاصة بك.' 
        : 'Preventive and curative maintenance services for flow meters and online analyzers, ensuring the reliability and accuracy of your measurement equipment.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    },
    {
      title: language === 'fr' ? 'Vérification des systèmes de comptage' : 
             language === 'ar' ? 'التحقق من أنظمة القياس' : 
             'Measurement systems verification',
      description: language === 'fr' 
        ? 'Vérification et validation des systèmes de comptage des gaz de torche pour assurer la précision des mesures et la conformité aux normes environnementales.' 
        : language === 'ar' 
        ? 'التحقق من والتصديق على أنظمة قياس غازات الشعلة لضمان دقة القياسات والامتثال للمعايير البيئية.' 
        : 'Verification and validation of flare gas measurement systems to ensure measurement accuracy and compliance with environmental standards.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      )
    },
    {
      title: language === 'fr' ? 'Formation sur site' : 
             language === 'ar' ? 'التدريب في الموقع' : 
             'On-site training',
      description: language === 'fr' 
        ? 'Formation sur site pour le personnel sur les systèmes de mesure, permettant à vos équipes de maîtriser l\'utilisation et la maintenance de base des équipements.' 
        : language === 'ar' 
        ? 'تدريب في الموقع للموظفين على أنظمة القياس، مما يتيح لفرقك إتقان استخدام المعدات والصيانة الأساسية.' 
        : 'On-site training for personnel on measurement systems, enabling your teams to master the use and basic maintenance of equipment.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    },
    {
      title: language === 'fr' ? 'Maintenance préventive' : 
             language === 'ar' ? 'الصيانة الوقائية' : 
             'Preventive maintenance',
      description: language === 'fr' 
        ? 'Programmes de maintenance préventive personnalisés pour prolonger la durée de vie de vos équipements et prévenir les pannes coûteuses.' 
        : language === 'ar' 
        ? 'برامج صيانة وقائية مخصصة لإطالة عمر معداتك ومنع الأعطال المكلفة.' 
        : 'Customized preventive maintenance programs to extend the life of your equipment and prevent costly breakdowns.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      title: language === 'fr' ? 'Mise à niveau des systèmes' : 
             language === 'ar' ? 'ترقية الأنظمة' : 
             'System upgrades',
      description: language === 'fr' 
        ? 'Services de mise à niveau pour moderniser vos systèmes existants avec les dernières technologies et fonctionnalités disponibles.' 
        : language === 'ar' 
        ? 'خدمات الترقية لتحديث أنظمتك الحالية بأحدث التقنيات والميزات المتاحة.' 
        : 'Upgrade services to modernize your existing systems with the latest technologies and features available.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    {
      title: language === 'fr' ? 'Certifications & Accréditations' : 
             language === 'ar' ? 'الشهادات والاعتمادات' : 
             'Certifications & Accreditations',
      description: language === 'fr' 
        ? 'Nos techniciens sont certifiés sur les produits Panametrics, Hobré, Masoneilan, et autres, garantissant un service de qualité conforme aux normes des fabricants.' 
        : language === 'ar' 
        ? 'فنيونا معتمدون على منتجات Panametrics و Hobré و Masoneilan وغيرها، مما يضمن خدمة عالية الجودة وفقًا لمعايير الشركات المصنعة.' 
        : 'Our technicians are certified on Panametrics, Hobré, Masoneilan products, and others, ensuring quality service in accordance with manufacturer standards.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '40px', height: '40px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    }
  ];

  return (
    <section className="section section-dark" style={{ 
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FF6B00' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        opacity: 0.5
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <h2 className="fade-in" style={{ 
          fontSize: '2.5rem', 
          marginBottom: '1rem',
          position: 'relative',
          paddingBottom: '1.5rem',
          textAlign: 'center'
        }}>
          {t('services.technical.title')}
          <span style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '80px',
            height: '4px',
            backgroundColor: 'var(--assco-orange)',
            borderRadius: '2px'
          }}></span>
        </h2>
        
        <p className="subtitle fade-in" style={{ 
          maxWidth: '800px',
          margin: '0 auto 4rem',
          fontSize: '1.125rem',
          color: 'var(--assco-gray-600)',
          textAlign: 'center'
        }}>
          {language === 'fr' 
            ? 'Notre équipe de techniciens certifiés offre une gamme complète de services techniques pour assurer le fonctionnement optimal de vos systèmes d\'instrumentation.' 
            : language === 'ar'
            ? 'يقدم فريقنا من الفنيين المعتمدين مجموعة كاملة من الخدمات الفنية لضمان التشغيل الأمثل لأنظمة القياس الخاصة بك.'
            : 'Our team of certified technicians offers a comprehensive range of technical services to ensure the optimal operation of your instrumentation systems.'}
        </p>
        
        <div className="grid" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
          gap: '2rem'
        }}>
          {technicalServices.map((service, index) => (
            <div 
              key={index}
              className="technical-service-card fade-in"
              style={{
                backgroundColor: 'white',
                borderRadius: 'var(--radius-lg)',
                padding: '2rem',
                boxShadow: 'var(--shadow-md)',
                transition: 'all 0.3s ease',
                border: '1px solid var(--assco-gray-100)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                animationDelay: `${0.1 * index}s`
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = 'var(--shadow-lg)';
                const iconBg = e.currentTarget.querySelector('.service-icon-bg');
                if (iconBg) {
                  iconBg.style.backgroundColor = 'var(--assco-orange)';
                }
                const icon = e.currentTarget.querySelector('.service-icon');
                if (icon) {
                  icon.style.color = 'white';
                }
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                const iconBg = e.currentTarget.querySelector('.service-icon-bg');
                if (iconBg) {
                  iconBg.style.backgroundColor = 'rgba(255, 107, 0, 0.1)';
                }
                const icon = e.currentTarget.querySelector('.service-icon');
                if (icon) {
                  icon.style.color = 'var(--assco-orange)';
                }
              }}
            >
              <div 
                className="service-icon-bg"
                style={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 107, 0, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1.5rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div className="service-icon" style={{ color: 'var(--assco-orange)', transition: 'all 0.3s ease' }}>
                  {service.icon}
                </div>
              </div>
              
              <h3 style={{ 
                fontSize: '1.5rem',
                marginBottom: '1rem',
                color: 'var(--assco-gray-900)'
              }}>
                {service.title}
              </h3>
              
              <p style={{ 
                color: 'var(--assco-gray-600)',
                lineHeight: '1.7',
                flex: '1'
              }}>
                {service.description}
              </p>
              
              <div style={{
                marginTop: '1.5rem',
                display: 'flex',
                justifyContent: 'flex-end'
              }}>
                <button 
                  className="btn-text"
                  style={{
                    color: 'var(--assco-orange)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    fontSize: '0.9375rem',
                    fontWeight: '500',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#e25a00';
                    e.currentTarget.style.gap = '0.75rem';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = 'var(--assco-orange)';
                    e.currentTarget.style.gap = '0.5rem';
                  }}
                >
                  {language === 'fr' ? 'En savoir plus' : 
                   language === 'ar' ? 'معرفة المزيد' : 
                   'Learn more'}
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '16px', height: '16px' }} viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <style jsx>{`
        /* Override section-dark styles for technical service cards */
        .section-dark .technical-service-card p,
        .section-dark .technical-service-card h3,
        .section-dark .technical-service-card span,
        .section-dark .technical-service-card li {
          color: var(--assco-gray-700) !important;
        }
        
        .section-dark .technical-service-card h3 {
          color: var(--assco-gray-800) !important;
        }
      `}</style>
    </section>
  );
};

export default TechnicalServicesSection;
